export default "__VITE_ASSET__edc2c2a7__"